module.exports = __webpack_public_path__ + "static/media/main-bird-0.dbe64eb6.png";